import type { MeterReading, MeterReadingBase } from "../../types";
import { createBaseService } from "./baseService";

const base = createBaseService<MeterReading, MeterReadingBase>({
  tableName: "meter_readings",
  viewName: "meter_readings_enriched",
  computedColumns: ["assetName", "recordedByName", "delta"],
  searchColumns: ["notes", "asset_name", "recorded_by_name"],
});

export class MeterReadingService {
  static getAll = base.getAll;
  static get = base.get;
  static create = base.create;
  static update = base.update;
  static delete = base.delete;
}
